import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import { Sale } from 'src/app/models/Sale';
import { SaleService } from 'src/app/services/partner/sale.service';
import * as _ from 'underscore';
@Component({
  selector: 'app-graf-ure-po-urah-stacked',
  templateUrl: './graf-ure-po-urah-stacked.component.html',
  styleUrls: ['./graf-ure-po-urah-stacked.component.css']
})
export class GrafUrePoUrahStackedComponent implements OnInit, OnChanges {
  @Input() dataList: Array<Sale>;
  @Input() saleFilter;
  public nameList = [];
  public titleList = [];
  public valueList: Array<Array<Sale>> = [[]];
  public calcLetosList: Array<Array<number>>;
  public calcLaniList: Array<Array<number>>;
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y;
            if (value >= 1000) {
              label += value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              label += value;
            }
            return label;
          },
          title: function (tooltipItems) {
            // Assuming 'stack' is stored in dataset metadata, otherwise adjust as needed
            const stack = tooltipItems[0].dataset.stack;
            return stack === 'letos' ? 'Letos' : 'Lani';
          }
        }
      }
    },

    scales: {
      y: {
        ticks: {
          callback: function (value, index, values) {
            value += '';
            var x = value.toString().split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + '.' + '$2');
            }
            return x1 + x2;
          },
        }
      },
    },
  };
  public barChartLabels: string[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataset[] = [
  ];

  constructor(private saleService: SaleService) {
  }
  ngOnChanges(changes: SimpleChanges) {
    //console.log(changes);
    /*if(changes.saleFilter.currentValue != changes.saleFilter.previousValue) {
      this.ngOnInit();
    }*/

    console.log(changes);
    console.log(changes.dataList);

    if (changes.dataList) {
      if (changes.dataList.currentValue) {
        if (changes.dataList.currentValue.length != 0) {
          this.dataList = changes.dataList.currentValue;
          this.ngOnInit();
        }
      }
    }

  }

  ngOnInit() {
    console.log('DATA LIST!!!');
    console.log(this.dataList);
    if (this.dataList != undefined) {
      if (this.dataList.length != 0) {
        console.log('gre nt');
        console.log(this.dataList);
        this.dataList.reverse();
        this.getAllNames();
        this.getValues();
        this.getTitles();
        this.getCalcValues();
        this.createGraph();
      }
    }
    console.log(this.barChartData)
  }

  getAllNames() {
    this.nameList = [];
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.nameList.length === 0) {
        this.nameList.push(this.dataList[i].date);
      } else {
        if (!this.nameList.includes(this.dataList[i].date)) {
          this.nameList.push(this.dataList[i].date);
        }
      }
    }
    console.log(this.nameList);
  }

  getTitles() {
    this.titleList = [];
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.titleList.length === 0) {
        this.titleList.push(this.dataList[i].title);
      } else {
        if (!this.titleList.includes(this.dataList[i].title)) {
          this.titleList.push(this.dataList[i].title);
        }
      }
    }
    this.titleList = this.titleList;
    console.log(this.titleList);
  }
  getValues() {
    this.valueList = [];
    this.valueList = [[]];
    console.log(this.valueList);
    console.log(this.dataList);
    for (let i = 0; i < this.nameList.length; i++) {
      this.valueList[i] = [];
      for (let j = 0; j < this.dataList.length; j++) {
        if (this.nameList[i] === this.dataList[j].date) {
          console.log(this.dataList[j]);
          console.log(this.valueList[i]);
          this.valueList[i].push(this.dataList[j]);
        }
      }
    }
    console.log(this.valueList);
  }

  getCalcValues() {
    for (let i = 0; i < this.valueList.length; i++) {
      this.calcLetosList = [[]];
      this.calcLaniList = [[]];
      for (let j = this.titleList.length - 1; j >= 0; j--) {
        if (this.saleFilter === 'SALEVALUE') {
          this.calcLetosList[i].push(this.valueList[i][j].saleVal);
          this.calcLaniList[i].push(this.valueList[i][j].saleValCmp);
        } else if (this.saleFilter === 'SALEVALUEWT') {
          this.calcLetosList[i].push(this.valueList[i][j].saleValWT);
          this.calcLaniList[i].push(this.valueList[i][j].saleValWTCmp);
        } else if (this.saleFilter === 'MARGINPERCENT') {
          this.calcLetosList[i].push(this.valueList[i][j].marginPrc);
          this.calcLaniList[i].push(this.valueList[i][j].marginPrcCmp);
        }
      }
    }
  }

  createGraph() {
    let joinedArr = [];
    for (let i = 0; i < this.titleList.length; i++) {
      joinedArr.push({
        title: this.titleList[i], calcLetosList: this.calcLetosList[i],
        calcLaniList: this.calcLaniList[i], nameList: this.nameList[i]
      });
    }
    joinedArr = _.sortBy(joinedArr, 'title');
    this.barChartData = [];
    for (let i = 0; i < this.valueList.length; i++) {
      this.barChartData.push({ data: this.calcLetosList[i].reverse(), label: this.nameList[i], stack: 'letos' });
      this.barChartData.push({ data: this.calcLaniList[i].reverse(), label: this.nameList[i], stack: 'lani' });
    }

    this.barChartLabels = this.titleList;
    console.log(this.barChartData)
  }
}
